<template>
    <div>
        <footer class="footer-section" style="margin-top: 100px;">
        <div class="container">
            <div class="footer-cta pt-5 pb-5">
                <div class="row">
                    <div class="col-xl-4 col-md-4 mb-30">
                        <div class="single-cta">
                            <i class="fas fa-map-marker-alt"></i>
                            <div class="cta-text">
                                <h4>Find us</h4>
                                <a href="https://maps.app.goo.gl/LrhcjifGc9d6KXPCA">
                                  <span>I BRAND BD, Lalbagh Dhaka-1211</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-md-4 mb-30">
                        <div class="single-cta">
                            <i class="fas fa-phone"></i>
                            <div class="cta-text">
                                <h4>Call us</h4>
                
                                    <a href="tel:+8801771-997014">
                                        <span>+8801771-997014</span>
                                    </a>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-md-4 mb-30">
                        <div class="single-cta">
                            <i class="far fa-envelope-open"></i>
                            <div class="cta-text">
                                <h4>Mail us</h4>
                                <a href="mailto:info.ibrand.bd@gmail.com"><span>info.ibrand.bd@gmail.com</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-content pt-5 pb-5">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 mb-50">
                        <div class="footer-widget">
                            <div class="footer-logo">
                              <router-link active-class="active" exact class="navbar-brand" to="/">
                                <a href="#"><img src="/img/logo.png" class="img-fluid" alt="logo"></a>
                              </router-link>
                            </div>
                            <div class="footer-text">
                                <p>If you order online, you can get up to 10% discount on any product! and We always have various discounts in this company, so always try to stay with us. Stay tuned with like and follow now to get our offers.</p>
                            </div>
                            <div class="footer-social-icon">
                                <span>Follow us</span>
                                <a href="https://www.facebook.com/ibrand.bd.shop"><i class="fab fa-facebook-f facebook-bg"></i></a>
                                <a href="https://www.instagram.com/ibrand.bd.shop"><i class="fa-brands fa-instagram" style="margin: 0; padding: 0; background-color: #fff; color: #060606;"></i></a>
                                <a href="https://www.youtube.com/@ibrandbd"><i class="fa-brands fa-youtube" style="margin: 0; padding: 0; background-color: #fff; color: #060606;"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Useful Links</h3>
                            </div>
                            <ul>
                              <li>
                                  <router-link to="/">
                                    Home
                                  </router-link>
                                </li>
                                <li>
                                  <router-link to="/about">
                                    About
                                  </router-link>
                                </li>
                                <li><a href="#">Product</a></li>
                                <li>
                                  <router-link to="/panjabi-collection">
                                    Panjabi
                                  </router-link>
                                </li>
                                <li>
                                  <router-link to="/shirt-collection">
                                    Shirt
                                  </router-link>
                                </li>
                                <li>
                                  <router-link to="/pant-collection">
                                    Pant
                                  </router-link>
                                </li>
                                <li>
                                  <router-link to="/contract">
                                    Contract
                                  </router-link>
                                </li>
                                <li><a href="#">Expert Team</a></li>
                                <li><a href="#">Product Updet</a></li>
                                <li><a href="#">Massage</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-50">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Subscribe</h3>
                            </div>
                            <div class="footer-text mb-25">
                                <p>Submit your email for more updates</p>
                            </div>
                            <div class="subscribe-form">
                                <form action="https://formspree.io/f/xbjnjlol" method="POST">
                                    <input name="Only Email Submit" type="email" id="email" placeholder="Email Address">
                                    <button ><i class="fab fa-telegram-plane"></i></button>
                                </form>
                            </div>
                            <div>
                              <img src="/img/payment.png" style="width: 250px; margin-left: -5px; padding-top: 20px;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    </div>
</template>

<script>
    export default {
        name: 'FooterCompo'
    }
</script>

<style>
    ul {
    margin: 0px;
    padding: 0px;
}
.footer-section {
  background: #060606;
  position: relative;
}
.footer-cta {
  border-bottom: 1px solid #373636;
}
.single-cta i {
  color: #ffffff;
  font-size: 30px;
  float: left;
  margin-top: 8px;
}
.cta-text {
  padding-left: 15px;
  display: inline-block;
}
.cta-text h4 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 2px;
}
.cta-text span {
  color: #757575;
  font-size: 15px;
}
.footer-content {
  position: relative;
  z-index: 2;
}
.footer-pattern img {
  position: absolute;
  top: 0;
  left: 0;
  height: 330px;
  background-size: cover;
  background-position: 100% 100%;
}
.footer-logo {
  margin-bottom: 30px;
}
.footer-logo img {
    max-width: 200px;
}
.footer-text p {
  margin-bottom: 14px;
  font-size: 14px;
      color: #7e7e7e;
  line-height: 20px;
}
.footer-social-icon span {
  color: #fff;
  display: block;
  font-size: 20px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 20px;
}
.footer-social-icon a {
  color: #fff;
  font-size: 16px;
  margin-right: 15px;
}
.footer-social-icon i {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 38px;
  border-radius: 50%;
}
.facebook-bg{
  background: #fff;
  color: #060606;
}
.twitter-bg{
  background: #fff;
  color: #060606;
}
.google-bg{
  background: #fff;
  color: #060606;
}
.footer-widget-heading h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 40px;
  position: relative;
}
.footer-widget-heading h3::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -15px;
  height: 2px;
  width: 50px;
  background: #fff;
}
.footer-widget ul li {
  display: inline-block;
  float: left;
  width: 50%;
  margin-bottom: 12px;
}
.footer-widget ul li a:hover{
  color: #fff;
}
.footer-widget ul li a {
  color: #878787;
  text-transform: capitalize;
}
.subscribe-form {
  position: relative;
  overflow: hidden;
}
.subscribe-form input {
  width: 100%;
  padding: 14px 28px;
  background: #2E2E2E;
  border: 1px solid #2E2E2E;
  color: #fff;
  outline: none;
}
.subscribe-form button {
    position: absolute;
    right: 0;
    background: #fff;
    padding: 13px 20px;
    border: 1px solid #fff;
    top: 0;
}
.subscribe-form button i {
  color: #060606;
  font-size: 22px;
  transform: rotate(-6deg);
}
.copyright-area{
  background: #202020;
  padding: 25px 0;
}
.copyright-text p {
  margin: 0;
  font-size: 14px;
  color: #878787;
}
.copyright-text p a{
  color: #ff5e14;
}
.footer-menu li {
  display: inline-block;
  margin-left: 20px;
}
.footer-menu li:hover a{
  color: #ff5e14;
}
.footer-menu li a {
  font-size: 14px;
  color: #878787;
}
</style>